import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Dimensions from "react-native-web/dist/exports/Dimensions";
import * as animatable from "react-native-animatable";

var _Dimensions$get = Dimensions.get("window"),
    height = _Dimensions$get.height,
    width = _Dimensions$get.width;

export var initializeAnimations = function initializeAnimations() {
  var makeSlideTranslation = function makeSlideTranslation(translationType, fromValue, toValue) {
    return {
      from: _defineProperty({}, translationType, fromValue),
      to: _defineProperty({}, translationType, toValue)
    };
  };

  var animationDefinitions = {
    slideInDown: makeSlideTranslation("translateY", -height, 0),
    slideInUp: makeSlideTranslation("translateY", height, 0),
    slideInLeft: makeSlideTranslation("translateX", -width, 0),
    slideInRight: makeSlideTranslation("translateX", width, 0),
    slideOutDown: makeSlideTranslation("translateY", 0, height),
    slideOutUp: makeSlideTranslation("translateY", 0, -height),
    slideOutLeft: makeSlideTranslation("translateX", 0, -width),
    slideOutRight: makeSlideTranslation("translateX", 0, width)
  };
  animatable.initializeRegistryWithDefinitions(animationDefinitions);
};

if (typeof initializeAnimations !== 'undefined' && initializeAnimations && initializeAnimations === Object(initializeAnimations) && Object.isExtensible(initializeAnimations) && !initializeAnimations.hasOwnProperty('__filemeta')) {
  Object.defineProperty(initializeAnimations, '__filemeta', {
    configurable: true,
    value: {
      name: "initializeAnimations",
      filename: "node_modules/react-native-modal/src/utils.js"
    }
  });
}

export var buildAnimations = function buildAnimations(_ref) {
  var animationIn = _ref.animationIn,
      animationOut = _ref.animationOut;
  var updatedAnimationIn = animationIn;
  var updatedAnimationOut = animationOut;

  if (isObject(animationIn)) {
    var animationName = JSON.stringify(animationIn);
    makeAnimation(animationName, animationIn);
    updatedAnimationIn = animationName;
  }

  if (isObject(animationOut)) {
    var _animationName = JSON.stringify(animationOut);

    makeAnimation(_animationName, animationOut);
    updatedAnimationOut = _animationName;
  }

  return {
    animationIn: updatedAnimationIn,
    animationOut: updatedAnimationOut
  };
};

if (typeof buildAnimations !== 'undefined' && buildAnimations && buildAnimations === Object(buildAnimations) && Object.isExtensible(buildAnimations) && !buildAnimations.hasOwnProperty('__filemeta')) {
  Object.defineProperty(buildAnimations, '__filemeta', {
    configurable: true,
    value: {
      name: "buildAnimations",
      filename: "node_modules/react-native-modal/src/utils.js"
    }
  });
}

var makeAnimation = function makeAnimation(name, obj) {
  animatable.registerAnimation(name, animatable.createAnimation(obj));
};

var isObject = function isObject(obj) {
  return obj !== null && typeof obj === "object";
};